module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C231"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("CONTENTS ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C233"
  }, [_c('span', {
    attrs: {
      "href": "#/html/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover ")])]), _vm._v(" "), _c('p', {
    staticClass: "Cov23"
  }, [_c('span', {
    attrs: {
      "href": "#/html/02_Copyrigh",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright ")])]), _vm._v(" "), _c('p', {
    staticClass: "Cov23"
  }, [_c('a', {
    attrs: {
      "href": "#/html/05_Introduc#page_ix"
    }
  }, [_vm._v("Introduction ")])]), _vm._v(" "), _c('p', {
    staticClass: "C632"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/html/06_PART_1_N#page_1"
    }
  }, [_vm._v("PART 1 NATURAL PROCESSES ")])])]), _vm._v(" "), _c('p', {
    staticClass: "P235"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_PART_1_N#page_3"
    }
  }, [_vm._v("1. The Nature of Life: Making Waste ")])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_PART_1_N#page_15"
    }
  }, [_vm._v("2. Nature Goes in Cycles ")])]), _vm._v(" "), _c('p', {
    staticClass: "C632"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/html/07_PART_2_O#page_23"
    }
  }, [_vm._v("PART 2 ONGOING PROCESSES IN THE HUMAN POPULATION ")])])]), _vm._v(" "), _c('p', {
    staticClass: "P17"
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_I__POPUL#page_25"
    }
  }, [_vm._v("I. POPULATION GROWTH AND ITS LIMITATIONS ")])]), _vm._v(" "), _c('p', {
    staticClass: "P17"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/09_A__The_G#page_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. The Growing Problem of Mankind ")])])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_A__The_G#page_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Population Growth and Agricultural Production ")])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_A__The_G#page_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Population Growth and Industrial Production ")])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_A__The_G#page_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Agribusiness and Corporate States ")])]), _vm._v(" "), _c('p', {
    staticClass: "P18"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/10_B__Exhau#page_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Exhausting and Wasting Our Resources ")])])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_B__Exhau#page_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Peak Oil and Beyond ")])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_B__Exhau#page_86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Limited Resources ")])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_B__Exhau#page_94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Man-Made Waste ")])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_B__Exhau#page_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. When It’s Gone, It’s Gone ")])]), _vm._v(" "), _c('p', {
    staticClass: "P18"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/11_C__Exhau#page_121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Exhausting and Wasting Our Environment ")])])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_C__Exhau#page_122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Our Freshwater Is Running Out! ")])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_C__Exhau#page_136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Polluting the Air and Warming Our Climate ")])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_C__Exhau#page_153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Deforestation and Its Consequences ")])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_C__Exhau#page_163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. The Loss of Biodiversity ")])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_C__Exhau#page_173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Wasted Land ")])]), _vm._v(" "), _c('p', {
    staticClass: "P18"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_II__TOWA#page_185",
      "id": "page_viii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. TOWARD A COLLAPSE OF OUR SOCIETY? ")])]), _vm._v(" "), _c('p', {
    staticClass: "P17"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/13_D__Proce#page_187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. Processes within the Human Population ")])])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_D__Proce#page_188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. What Is Overpopulation? ")])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_D__Proce#page_202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Bursting Out of Eden ")])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_D__Proce#page_214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Urbanization ")])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_D__Proce#page_220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Migration ")])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_D__Proce#page_229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. The Spread of Diseases ")])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_D__Proce#page_241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. The Dynamic Structure of Society ")])]), _vm._v(" "), _c('p', {
    staticClass: "P18"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/14_E__Proce#page_253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. Processes within the Global Society ")])])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_E__Proce#page_254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. From a Concrete to an Abstract World ")])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_E__Proce#page_264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. The Energy and Information Content of Society ")])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_E__Proce#page_278",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Can Our World Population Collapse? ")])]), _vm._v(" "), _c('p', {
    staticClass: "P17"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_III__THE#page_293",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. THE PERSISTENCE OF MANKIND ")])]), _vm._v(" "), _c('p', {
    staticClass: "P17"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/16_F__Anoth#page_295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F. Another Future for Our Human World? ")])])]), _vm._v(" "), _c('p', {
    staticClass: "P15"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_F__Anoth#page_296",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. The Road We Took, and the Way Forward ")])]), _vm._v(" "), _c('p', {
    staticClass: "C632"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_Epilogue#page_307",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue. The Emperor’s New Clothes ")])]), _vm._v(" "), _c('p', {
    staticClass: "P21"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_About_th#page_313",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author ")])]), _vm._v(" "), _c('p', {
    staticClass: "P18"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_Acknowle#page_315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments ")])]), _vm._v(" "), _c('p', {
    staticClass: "P18"
  }, [_c('span', {
    attrs: {
      "href": "#/html/20_Selected#page_317",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73961686","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/04_Contents.vue
// module id = 66
// module chunks = 0